export const nearbyCareGiversQuery = `query NearbyCareGivers($query: HealthCare_NearbyHealthCareGiversQueryInput!) {
    nearbyCareGivers(query: $query) {
      externalSourceName
      name
      careType
      distanceToPolicyHolderInKilometers
      policyPolicyDetails {
        contractStatus
        contractNumber
      }
    }
  }
`;
